export function extractApiErrorMessage(error, fallbackMessage = "Fehler bei der Anfrage.") {
  const responseData = error?.response?.data;
  if (typeof responseData === "string" && responseData.trim().length > 0) {
    return responseData;
  }

  const validationMessages = responseData?.errors && typeof responseData.errors === "object"
    ? Object.values(responseData.errors)
        .flatMap((value) => Array.isArray(value) ? value : [value])
        .filter((message) => typeof message === "string" && message.trim().length > 0)
    : [];
  if (validationMessages.length > 0) {
    return validationMessages.join(" ");
  }

  const detail = responseData?.detail || responseData?.title || responseData?.message;
  if (typeof detail === "string" && detail.trim().length > 0) {
    return detail;
  }

  if (error?.message) {
    return error.message;
  }

  return fallbackMessage;
}
